import { Component, ComponentFactoryResolver, OnInit } from "@angular/core";
import {
  CdkDragDrop,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { ReelsService } from "../../../../services/reels.service";
import { SwalService } from "../../../../shared/services/swal.service";
import { BroadcastService } from "../../../../shared/services/broadcast.service";
import { NRModalService } from "../../../../shared/modal/services/nrmodal.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CustomersService } from "../../../../services/customers.service";
import { ControlService } from "../../../../services/control.service";

interface MediaItem {
  id: string;
  title: string;
  thumb: string;
}

@Component({
  selector: 'app-design-reels',
  templateUrl: './design-reels.component.html',
  styleUrls: ['./design-reels.component.scss']
})
export class DesignReelsComponent implements OnInit {
  isAdmin: boolean = false;
	clientes: any[] = [];
	selectedClientId: number | null = null;

  reelsDisponibles = [
    {
      id: 1,
      name: 'Campaña Octubre Pepsi',
      descripcion: 'Promos 2x1',
      items: [/* ...clips... */],
      thumbs: [
        'url-thumb-1.jpg',
        'url-thumb-2.jpg',
        'url-thumb-3.jpg',
        'url-thumb-4.jpg'
      ]
    },
    {
      id: 2,
      name: 'Campaña Octubre coca',
      descripcion: 'Promos 2x1',
      items: [/* ...clips... */],
      thumbs: [
        'url-thumb-1.jpg',
        'url-thumb-2.jpg',
        'url-thumb-3.jpg',
        'url-thumb-4.jpg'
      ]
    },
  ];

  repertorio: MediaItem[] = [
    { id: 'm1', title: 'Anuncio Coca',      thumb: 'assets/img/brand/logo.png' },
    { id: 'm2', title: 'Promo 2x1',         thumb: 'assets/img/brand/logo.png' },
    { id: 'm3', title: 'Turismo Mérida',    thumb: 'assets/img/brand/logo.png' },
    { id: 'm4', title: 'Evento Feria',      thumb: 'assets/img/brand/logo.png' },
  ];

  reelTimeline: MediaItem[] = [];

  constructor(
      private reelsService: ReelsService,
      private swal: SwalService,
      private broadcast: BroadcastService,
      private componentFactoryResolver: ComponentFactoryResolver,
      private nrModal: NRModalService,
      private router: Router,
      private activatedRoute: ActivatedRoute,
      private customerService: CustomersService,
      private controlService: ControlService
    ) {
    }

  ngOnInit(): void {
    this.controlService.isAdmin().subscribe(res => {
			this.isAdmin = res.is_admin;
		});
  }

  onDropTimeline(event: CdkDragDrop<MediaItem[]>) {
    const fromList = event.previousContainer.data;
    const toList   = event.container.data;

    const isSameList = event.previousContainer === event.container;

    console.log('drop timeline', {
      fromList,
      toList,
      previousIndex: event.previousIndex,
      currentIndex: event.currentIndex,
      isSameList
    });

    if (isSameList) {
      // reorder interno en timeline
      moveItemInArray(toList, event.previousIndex, event.currentIndex);
      return;
    }

    // viene desde repertorio -> timeline
    const draggedItem = fromList[event.previousIndex];

    const cloned: MediaItem = {
      ...draggedItem,
      id: draggedItem.id + '_' + crypto.randomUUID(),
    };

    toList.splice(event.currentIndex, 0, cloned);
  }

  onDropRepertorio(event: CdkDragDrop<MediaItem[]>) {
    // catálogo fijo, no hacemos nada
    return;
  }

  saveTimeline() {
    // lógica para guardar el orden del reel
  }

  cancelTimeline() {
    // lógica para revertir o salir sin guardar
  }

  selectReel(r: any) {
    // ejemplo: cargar el reel seleccionado a la línea de tiempo actual
    this.reelTimeline = [...r.items];
  }
  
  createNewReel() {
    
  }
}
